module.exports = __webpack_public_path__ + "static/media/A1-15-Abdução-cod97.d0fa58b8.png";